import { c as _c } from "react/compiler-runtime";
import { Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
export const Fill = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Text as="span" bgColor="teal.solid/20" borderRadius="sm" color="teal.700" fontWeight="semibold" paddingX={1}>{children}</Text>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};